import React from 'react';

import { Ball, Icons } from 'widget/components';
import { useContentContext } from 'widget/content/content-context';
import { useWidgetContext } from 'widget/widget-context';

const Chat = () => {
  const { setIsWidgetActive } = useWidgetContext();
  const { setIsChatActive } = useContentContext();

  const handleClick = () => {
    setIsChatActive(true);
    setIsWidgetActive(false);
  };

  return (
    <Ball onClick={handleClick}>
      <Icons.ChatCircleDots fill="contrast" />
    </Ball>
  );
};

export default Chat;
